// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { OOI_EXPERIMENTS } from '@app/experiments';
import { AppState } from '../../common/types';

/** @deprecated Remove when merging {@link OOI_EXPERIMENTS.USE_NEW_TAG_CLOUD_SETTINGS_URL} */
export const getTagCloudWidgetData = (state: AppState) => {
  const tagsAsArray = state.tagCloudWidget.tags
    ? Object.values(state.tagCloudWidget.tags)
    : [];

  return {
    tags: tagsAsArray,
    translations: {
      emptyState: state.tagCloudWidget.emptyState ?? '',
      tags: state.tagCloudWidget.tags ?? {},
    },
  };
};
